import { useRegisterTopBarOverride } from "@/react/components/Mobile/hooks/topBar/useRegisterTopBarOverride";
import { CanvasMobileTopBar } from "@/react/components/Mobile/shell/topBar/CanvasMobileTopBar";

/**
 * Renderless component that registers the Canvas/AI shell's TopBar
 * override via context - see Mobile/docs/settings-tabs-override.md for
 * the general "self-null-and-register" pattern this follows.
 */
export const CanvasTopBarRegistrar = () => {
  useRegisterTopBarOverride(<CanvasMobileTopBar />, []);

  return null;
};
